/**
 * 担当案件の 2 つの一覧（要件定義 / 開発）をまとめて並べるセクション。
 *
 * 要件定義は開発の前段なので**要件定義一覧を上**に置く。2 つを分けているのは母集団が違うため:
 * 開発側は Gen2 母票（`project_detail_table`）を起点に担当子票を JOIN するが、要件定義側は
 * 母票の種別が「アサイン前」のままのものが大半で、要件定義セット子票の担当から母票を逆引きする。
 *
 * 取得フックを `MemberDetailContent` から引き取っているのは、あちらが 1 ファイルの行数上限に
 * 達しているのと、2 つの一覧が常に組で出る（片方だけ出す画面が無い）ため。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business メンバー詳細 / マイページの担当案件セクション。担当要件定義案件一覧（浅緑）と担当開発案件一覧（橙黄）をこの順で並べる
 * @graph-connects useMemberRequirementProjects [calls] 担当要件定義案件一覧の取得
 * @graph-connects useMemberProjects [calls] 担当開発案件一覧の取得
 * @graph-connects AssignedRequirementProjectsCard [calls] 担当要件定義案件一覧カード描画
 * @graph-connects AssignedProjectsCard [calls] 担当開発案件一覧カード描画
 */

import { useMemberProjects, useMemberRequirementProjects } from '../../../hooks/useProjects.js';
import { AssignedProjectsCard } from './AssignedProjectsCard.js';
import { AssignedRequirementProjectsCard } from './AssignedRequirementProjectsCard.js';

/** @graph-connects none */
interface MemberAssignedProjectsSectionProps {
  /** 対象メンバーのメールアドレス。 */
  email: string;
  /**
   * 開発一覧の平均健康度ラベルの位置合わせを再計測するトリガー
   * （`AssignedProjectsCard` の `alignReadyKey` へそのまま渡す）。
   */
  alignReadyKey?: unknown;
}

/** @graph-connects none */
export function MemberAssignedProjectsSection({
  email,
  alignReadyKey,
}: MemberAssignedProjectsSectionProps) {
  const { data: requirementProjectsData, isLoading: isRequirementProjectsLoading } =
    useMemberRequirementProjects(email);
  const { data: memberProjectsData, isLoading: isMemberProjectsLoading } = useMemberProjects(email);

  return (
    <>
      {/* 担当要件定義案件一覧（母票の案件キー / 案件名 / ステータスのみ） */}
      <AssignedRequirementProjectsCard
        data={requirementProjectsData}
        isLoading={isRequirementProjectsLoading}
      />

      {/* 担当開発案件一覧（担当中PJの平均健康度をステータス列上に表示） */}
      <AssignedProjectsCard
        data={memberProjectsData}
        isLoading={isMemberProjectsLoading}
        alignReadyKey={alignReadyKey}
      />
    </>
  );
}
